// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__3-WDD","fileDisabled":"File_fileDisabled__2WL5f"};